import { connect } from 'react-redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { CompositeSessionInfoSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { selectCatalogingOnSiteEnabled } from '~src/catalog/selectors/CatalogSelectors';
import { addContentFavorite, removeContentFavorite } from '~src/favorites/actions/FavoritesActions';
import { contentCountsUpToDate } from '~src/spacesPlatform/actions/ContentCountsActions';
import { populateContentBreadcrumbs } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbHelpers';
import { selectContentCounts, selectContentCountsUpToDate } from '~src/spacesPlatform/selectors/ContentCountsSelector';
import { PublishedConnectionTableSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { enterPublishedConnectionTableSubspace } from '../actions/EnterPublishedConnectionTableSubspaceAction';
import { publishedConnectionTableCountsRequest } from '../actions/PublishedConnectionTableCountsRequestAction';
import {
  PublishedConnectionTableSpace,
  PublishedConnectionTableSpaceDispatchProps,
  PublishedConnectionTableSpaceOwnProps,
  PublishedConnectionTableSpaceStateProps,
} from './PublishedConnectionTableSpace';

const mapStateToProps: MapStateToProps<PublishedConnectionTableSpaceStateProps> = (state) => ({
  contentCountsPublishedConnectionTable: selectContentCounts<'virtualConnectionTable'>(state, 'virtualConnectionTable'),
  urls: siteUrlsSelector(state),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state)
});

const mapDispatchToProps: MapDispatchToProps<PublishedConnectionTableSpaceDispatchProps, PublishedConnectionTableSpaceOwnProps> = (dispatch, ownProps) => ({
  addToFavorites: () => {
    dispatch(addContentFavorite(ownProps.publishedConnectionTableDetailInfo));
  },
  enterSpace: (requestContent: boolean) => {
    dispatch(enterPublishedConnectionTableSubspace(
      ownProps.publishedConnectionTableDetailInfo,
      ownProps.subplaceName as PublishedConnectionTableSubspaceName,
      requestContent
    ));
  },
  fetchUpdatedContentCounts: () => {
    dispatch(publishedConnectionTableCountsRequest('virtualConnectionTable'));
  },
  markContentCountsUpToDate: () => {
    dispatch(contentCountsUpToDate());
  },
  populateContentBreadcrumbs,
  removeFromFavorites: () => {
    dispatch(removeContentFavorite(ownProps.publishedConnectionTableDetailInfo));
  },
});

export const ConnectedPublishedConnectionTableSpace = connect(mapStateToProps, mapDispatchToProps)(PublishedConnectionTableSpace);
